import { createSlice } from '@reduxjs/toolkit';

// بررسی وضعیت تم در localStorage
const getSavedTheme = () => {
  try {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme === 'dark';
  } catch (error) {
    console.error('Error accessing localStorage:', error);
    return false;
  }
};

const initialState = {
  isDarkMode: getSavedTheme(),
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.isDarkMode = !state.isDarkMode;
      try {
        localStorage.setItem('theme', state.isDarkMode ? 'dark' : 'light');
      } catch (error) {
        console.error('Error saving theme to localStorage:', error);
      }
    },
    setDarkMode: (state) => {
      state.isDarkMode = true;
      try {
        localStorage.setItem('theme', 'dark');
      } catch (error) {
        console.error('Error saving theme to localStorage:', error);
      }
    },
    setLightMode: (state) => {
      state.isDarkMode = false;
      try {
        localStorage.setItem('theme', 'light');
      } catch (error) {
        console.error('Error saving theme to localStorage:', error);
      }
    },
  },
});

export const { toggleTheme, setDarkMode, setLightMode } = themeSlice.actions;

export default themeSlice.reducer;
